import styled from 'styled-components';

import { Table } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getReportList } from '../../../api/Report';
import { currentUser } from '../../../features/user/userSlice';

const TableContainer = styled.div`
  /* margin-bottom: 20px; */
  overflow: hidden;
  height: 100%;
`;

export const CardTitle = styled.div`
  position: relative;
  font-size: 24px;
  margin-top: 20px;
  font-weight: 600;
  padding-left: 14px;
  ::before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 80%;
    width: 5px;
    background-color: #40a9ff;
  }
`;

const CommonTable = ({ ...props }) => {
  const { t } = useTranslation();
  const Columns = [
    {
      title: (
        <span
          style={{
            fontSize: '14px',
            fontWeight: 400,
          }}
        >
          {t('CommonTable.title')}
        </span>
      ),
      dataIndex: 'title',
      key: 'title',
      render: (_, { serial_number }) => (
        <Link to={`/report/detail/${serial_number}`}>{_}</Link>
      ),
      width: '320px',
      className: 'common-table-title',
    },
    {
      title: (
        <span
          style={{
            fontSize: '14px',
            fontWeight: 400,
          }}
        >
          {t('CommonTable.category')}
        </span>
      ),
      dataIndex: 'category',
      key: 'category',
      width: 80,
      align: 'center',
      className: 'common-table-lv',
    },
    {
      title: (
        <span
          style={{
            fontSize: '14px',
            fontWeight: 400,
          }}
        >
          {t('CommonTable.status')}
        </span>
      ),
      dataIndex: 'status',
      key: 'status',
      render: (_, { user }) => user.name,
      width: 70,
      align: 'center',
      className: 'common-table-author',
    },
    {
      title: (
        <span
          style={{
            fontSize: '14px',
            fontWeight: 400,
          }}
        >
          {t('CommonTable.createDate')}
        </span>
      ),
      dataIndex: 'created_at',
      key: 'created_at',
      width: 120,
      align: 'center',
      render: (_) => moment.unix(_).format('YYYY-MM-DD'),
      className: 'common-table-cell-date',
    },
    {
      title: (
        <span
          style={{
            fontSize: '14px',
            fontWeight: 400,
          }}
        >
          {t('CommonTable.operate')}
        </span>
      ),
      // dataIndex: 'operate',
      // key: 'operate',
      render: (_, { user }) => user.name,
      width: 70,
      align: 'center',
      fixed: 'right',
      className: 'common-table-author',
    },
  ];

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageOptions, setPageOptions] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const user = useSelector(currentUser);

  const fetecData = async () => {
    setLoading(true);
    try {
      const { code, data } = await getReportList({
        user_id: user.user.id,
        page: pageOptions.current,
      });
      if (code === '10000') {
        setData(data.list);
        setPageOptions({
          current: data.current_page,
          pageSize: data.per_page,
          total: data.total,
        });
      }

      setLoading(false);
    } catch (error) {
      // console.log(error);
    }
  };

  useEffect(() => {
    fetecData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <TableContainer>
      {/* {title ? <CardTitle>{title}</CardTitle> : null} */}
      <Table
        columns={Columns}
        dataSource={data}
        pagination={{
          ...pageOptions,
          onChange(page, pageSize) {
            setPageOptions({
              ...pageOptions,
              current: page,
              pageSize,
            });
            fetecData();
          },
        }}
        loading={loading}
        className="common-table"
        rowKey="created_at"
        scroll={{
          x: 'max-content',
        }}
        style={{
          height: '100%',
        }}
      />
    </TableContainer>
  );
};

export default CommonTable;
